import { defaultHttpClient } from '../../httpClient';

export const postRestockNotification = (goodsOptionSno: number) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: `/api/v2/goods_options/${goodsOptionSno}/restock_notification/`,
    })
    .then(result => result.data);
};
